var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('a-table',{attrs:{"columns":_vm.itemColumns,"data-source":_vm.items,"pagination":false,"scroll":{ y: 200 }}}),_c('a-table',{staticStyle:{"margin-top":"15px"},attrs:{"columns":_vm.nodeColumns,"data-source":_vm.nodes,"pagination":false,"scroll":{ y: 200 }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }